import React from 'react';
import {  Row, Col, Layout, Alert } from 'antd';
import axios from 'axios';
import apiPath from 'apiPath';
import withSpin from 'components/withSpin';
import App from 'localcomponents/App';
const { Content } = Layout;

import ChooseFolioModal from '../Login/ChooseFolioModal';
import { getBrandBlue } from '../../theme';

class TargetXSSO extends React.Component {
    state = {
		redirectHome: false,
        showFolioModal: false,
		showError: false,
		destination: "/portal",
		chooseFromFolios: []
    }
    
    handleChooseFolio = (folioId) => {
		this.props.isLoading();
		axios.post(apiPath+'/auth/withFolio', {FolioId: folioId},{withCredentials: true}).then(result => {
			this.props.isDoneLoading();
			this.setState({ redirectHome: true });
		}).catch(error => {
            this.props.isDoneLoading();
            this.setState({ showError: true });
			//console.error(error);
		});
	}
	componentDidMount() {
		const blue = getBrandBlue();
		this.setState({ blue });
		document.body.style.backgroundColor = blue;

		const token = this.props.match.params.token;


		var dest = "/portal";
		if(this.props.match.params.destination){
			if(this.props.match.params.destination === "fa"){
				dest = "/portal/financial/Program%20Fee%20Payment%20Status";
			}
			else if(this.props.match.params.destination === "fp"){
				dest = "/portal/field/Browse%20All";
			}

		}

		this.setState({
			destination: dest
		});

        this.props.isLoading();
        axios.post(apiPath+'/auth/targetx', {
			Token: token
		},{
			withCredentials: true
		}).then(result => {
			this.props.isDoneLoading();
			if (result.data.folios) {
				this.setState({
					showFolioModal: true,
					chooseFromFolios: result.data.folios
				});
			} else {
				this.setState({ redirectHome: true });
				this.props.history.push(this.state.destination);
				location.reload();
			}
		}).catch(error => {
            this.props.isDoneLoading();
            this.setState({ showError: true });
			//console.error(error);
		});
	}
	render() {
		return (
			<App props={this.props}>
            <Row style={{marginTop: '16pt'}}>
                <Col xs={{span: 20, offset: 2}} sm={{span: 10, offset: 7}} style={{padding:'6vmin 0 12vmin 0'}}>
                    <Layout>
                        <Content>
                        {!this.state.showError && 
                            <div>
                                <ChooseFolioModal
                                visible={this.state.showFolioModal}
                                onChoose={this.handleChooseFolio}
                                onCancel={() => this.setState({ showFolioModal: false })}
                                folios={this.state.chooseFromFolios} />

                                <Alert showIcon type="info"
									message={<span>Please wait while we log you in.</span>}
									 />
                            </div>
                        }
                        {this.state.showError &&
                            <div>
                            <Alert showIcon type="error"
									message={<span>There was an issue logging you in. Please try again.</span>}
									 />
                            </div>
                        }
                        </Content>
                    </Layout>
                </Col>
			</Row>
			</App>
		);
	}
}


export default withSpin(TargetXSSO);


// WEBPACK FOOTER //
// ./src/containers/TargetXSSO/index.jsx